
/* Oct 20 (Jacob): holiday page fun pass. Unwrap-the-box hero (reveals the current phase's deal, remembered per session),
   "who's on your list" gift picker, and the candy cane spend ladder (reads the live cart total).
   LADDER: $35 free shipping is real. $45 free ring is the site's existing gift (currently OFF, window.__GIFTOFF).
   $65 free oil is a PLACEHOLDER until the free gift is decided. */
(function(){
  var C='https://cdn.shopify.com/s/files/1/0018/1465/9187/files/';
  var LADDER=[
    {at:35,t:'Free shipping'},
    {at:45,t:'A free scent ring'},
    {at:65,t:'A free holiday oil'}
  ];
  var WHO=[
    {k:'cowork',l:'The coworker',n:'Ring Collection',p:'$24.99',img:C+'hol-rings.jpg?v=1792519521&width=700',why:'Five rings for five kinds of Monday. Thoughtful, not too much.',go:'sets'},
    {k:'white',l:'The white elephant',n:'Candy Cane 3-Pack',p:'$18.99',img:C+'cc-sachet-angle-fb-1000.jpg?v=1792433521&width=700',why:'Under $20, actually useful, and nobody will steal it back. OK, someone will.',href:'/pages/candy-cane'},
    {k:'host',l:'The holiday host',n:'Ring + Oil Combo',p:'$64.99',img:C+'hol-combo.jpg?v=1792519521&width=700',why:"They're feeding twelve people. Give them a breather they can keep refilling.",go:'sets'},
    {k:'inlaws',l:'The in-laws',n:'Holiday Sanctuary Set',p:'$119.99',img:C+'Diffuser_on_counter4.jpg?v=1768389662&width=700',why:'Generous without being weird. A diffuser for the house and rings for the long visit.',go:'sets'},
    {k:'outdoors',l:'The outdoorsy one',n:'Log Cabin',p:'Limited edition',img:C+'lc-cab-pouch.jpg?v=1792449624&width=700',why:'Fir, pine and cedarwood. Basically a cabin weekend they can wear.',href:'/pages/log-cabin'},
    {k:'everything',l:'The one who has everything',n:'Oil Collection',p:'$49.99',img:C+'hol-oils.jpg?v=1792519521&width=700',why:"Bet they don't have this. Five oils to soak their rings in all winter.",go:'sets'},
    {k:'me',l:'Me (no judgment)',n:'Candy Cane Refresh Kit',p:'$37.99',img:C+'cc-kit-black-fb-1000.jpg?v=1792433521&width=700',why:"You've been wrapping gifts since 1am. You've earned this one.",href:'/pages/candy-cane'}
  ];
  function root(){return document.getElementById('view-holiday')}
  function reduced(){return window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches}
  function open(animate){
    var r=root();if(!r)return;
    r.classList.add('is-open');
    r.querySelector('.hol-reveal').hidden=false;
    r.querySelector('.hol-shop-btn').hidden=false;
    try{sessionStorage.setItem('esHolOpen','1')}catch(e){}
    if(animate&&!reduced())confetti(r);
  }
  function confetti(r){
    var box=r.querySelector('.hol-confetti'),z=r.querySelector('.hol-giftzone');if(!box||!z)return;
    var hb=r.querySelector('.hol-hero').getBoundingClientRect(),gb=z.getBoundingClientRect();
    var cx=gb.left-hb.left+gb.width/2,cy=gb.top-hb.top+gb.height/2;
    var cols=['#D4142F','#FFC93C','#FFF7EC','#2F5A43','#E76A7B'],h='';
    for(var i=0;i<54;i++){
      var a=Math.random()*Math.PI*2,d=160+Math.random()*320;
      h+='<i class="hol-bit" style="left:'+cx+'px;top:'+cy+'px;background:'+cols[i%cols.length]+';--dx:'+Math.round(Math.cos(a)*d)+'px;--dy:'+Math.round(Math.sin(a)*d-120)+'px;--r:'+Math.round(Math.random()*720-360)+'deg;animation-delay:'+(Math.random()*.15).toFixed(2)+'s"></i>';
    }
    box.innerHTML=h;setTimeout(function(){box.innerHTML=''},2200);
  }
  window.holUnwrap=function(){var r=root();if(!r||r.classList.contains('is-open'))return;open(true)};
  function pick(w,first){
    var r=root(),m=r.querySelector('.hol-match');
    r.querySelectorAll('.hol-chip').forEach(function(b){b.setAttribute('aria-pressed',b.getAttribute('data-k')===w.k?'true':'false')});
    var img=m.querySelector('.hol-match-img');img.src=w.img;img.alt=w.n;
    m.querySelector('.hol-match-n').textContent=w.n;
    m.querySelector('.hol-match-why').textContent=w.why;
    m.querySelector('.hol-match-p').textContent=w.p;
    var go=m.querySelector('.hol-match-go');
    go.textContent=w.href?'Shop '+w.n:'See the gift set';
    go.onclick=function(){if(w.href){location.href=w.href}else if(window.holScroll){holScroll('hol-sets')}};
    if(!first){m.classList.remove('swap');void m.offsetWidth;m.classList.add('swap')}
  }
  function chips(){
    var r=root(),c=r.querySelector('.hol-chips');if(!c||c.childElementCount)return;
    WHO.forEach(function(w){var b=document.createElement('button');b.type='button';b.className='hol-chip';b.setAttribute('data-k',w.k);b.setAttribute('aria-pressed','false');b.textContent=w.l;b.onclick=function(){pick(w)};c.appendChild(b)});
    pick(WHO[0],true);
  }
  var lastT=-1;
  function ladder(){
    var r=root();if(!r)return;
    var t=typeof cartTotal==='function'?cartTotal():0;if(t===lastT)return;lastT=t;
    var max=LADDER[LADDER.length-1].at,tiers=r.querySelector('.hol-tiers');
    if(!tiers.childElementCount)tiers.innerHTML=LADDER.map(function(x){return '<div class="hol-tier"><b>$'+x.at+'</b><span>'+x.t+'</span><em></em></div>'}).join('');
    r.querySelector('.hol-cane-fill').style.width=Math.min(100,t/max*100).toFixed(1)+'%';
    r.querySelector('.hol-cane').classList.toggle('full',t>=max);
    var next=null;
    tiers.querySelectorAll('.hol-tier').forEach(function(el,i){var x=LADDER[i],on=t>=x.at;el.classList.toggle('on',on);el.querySelector('em').textContent=on?'Unlocked':'$'+(x.at-t).toFixed(2)+' to go';if(!on&&!next)next=x});
    var msg=r.querySelector('.hol-ladder-msg'),wrapM=function(h){msg.innerHTML='<span data-nocase>'+h+'</span>'};
    if(t<=0)wrapM('Your cart is empty. Add <b>$'+LADDER[0].at+'</b> and the first stripe is yours.');
    else if(next)wrapM('Your cart: $'+t.toFixed(2)+'. Add <b>$'+(next.at-t).toFixed(2)+'</b> more for '+next.t.toLowerCase()+'.');
    else wrapM('Your cart: $'+t.toFixed(2)+'. <b>You unlocked everything.</b> Nice work, elf.');
  }
  var was=false,lt=null;
  setInterval(function(){
    var on=window.current==='holiday';
    if(on&&!was){
      var seen=false;try{seen=!!sessionStorage.getItem('esHolOpen')}catch(e){}
      if(seen)open(false);
      chips();lastT=-1;ladder();if(!lt)lt=setInterval(ladder,1000);
    }
    if(!on&&was&&lt){clearInterval(lt);lt=null}
    was=on;
  },400);
})();
